'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin: ', ';\n'], ['\n  margin: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var position = _ref.position;
  return position === 'left' ? '0px 10px 0px 0px' : '0px 0px 0px 10px';
});

var Arrow = function Arrow(_ref2) {
  var position = _ref2.position,
      disabled = _ref2.disabled,
      startScrolling = _ref2.startScrolling,
      endScrolling = _ref2.endScrolling;
  return _react2.default.createElement(Container, {
    position: position
  }, _react2.default.createElement(_Button2.default, {
    theme: 'grey',
    icon: position,
    disabled: disabled,
    onMouseDown: function onMouseDown(e) {
      return startScrolling(position);
    },
    onMouseUp: endScrolling,
    outline: true
  }));
};

Arrow.propTypes = {
  position: _propTypes2.default.oneOf(['left', 'right']).isRequired,
  disabled: _propTypes2.default.bool,
  startScrolling: _propTypes2.default.func,
  endScrolling: _propTypes2.default.func
};
exports.default = Arrow;